module.exports = __webpack_public_path__ + "static/media/newUserCorp.81bba5b9.svg";